import cloneDeep from 'lodash.clonedeep'
import { getDataFromLS } from '@/utils'
import {
  contractsConfig,
  amendmentsConfig,
  contragentsConfig,
  actsConfig,
  paymentsConfig,
  lawCasesConfig,
  proceduresConfig,
  resourcesConfig,
  experienceConfig,
  timeTableConfig,
  contractsRegisterConfig
} from '@/config/filters'

const company = getDataFromLS('company', 'all')
let contracts = getDataFromLS('contracts', contractsConfig)
if (Object.keys(contractsConfig).some(p => contracts[p] === undefined)) {
  contracts = contractsConfig
}
const amendments = getDataFromLS('amendments', amendmentsConfig)
const contragents = getDataFromLS('contragents', contragentsConfig)
const acts = getDataFromLS('acts', actsConfig)
const actsMode = getDataFromLS('actsMode', 'list')
const payments = getDataFromLS('payments', paymentsConfig)
const lawCases = getDataFromLS('lawCases', lawCasesConfig)
const procedures = getDataFromLS('procedures', proceduresConfig)
const resources = getDataFromLS('resources', resourcesConfig)
let experience = getDataFromLS('experience', experienceConfig)
if (Object.keys(experienceConfig).some(p => experience[p] === undefined)) {
  experience = experienceConfig
}
let timeTable = getDataFromLS('timeTable', timeTableConfig)
if (Object.keys(timeTableConfig).some(p => timeTable[p] === undefined)) {
  timeTable = timeTableConfig
}
let contractsRegister = getDataFromLS(
  'contractsRegister',
  contractsRegisterConfig
)
if (
  Object.keys(contractsRegisterConfig).some(
    p => contractsRegister[p] === undefined
  )
) {
  contractsRegister = contractsRegisterConfig
}

const state = {
  company,
  contracts,
  amendments,
  contragents,
  acts,
  actsMode,
  payments,
  lawCases,
  procedures,
  resources,
  experience,
  timeTable,
  contractsRegister
}

const typesConfig = {
  experience: experienceConfig,
  timeTable: timeTableConfig
}

const mutations = {
  CHANGE_FILTER (state, { type, field, value }) {
    state[type][field] = value
  },
  SET_COMPANY (state, company) {
    state.company = company
  },
  SET_VIEW_MODE (state, { name, value }) {
    state[name] = value
  },
  CLEAR_FILTERS (state, type) {
    const defaultValue = cloneDeep(typesConfig[type])

    if (type === 'experience') {
      defaultValue.status = state.experience.status
    }

    state[type] = defaultValue
  }
}

export default {
  state,
  mutations
}
